
import classnames from "classnames"

import { useHistory } from "react-router-dom"

import { useScenario } from "../contexts/ScenarioContext"

import SubPhaseNav from "./SubPhaseNav"

const PhaseNav = ({baseURL, activeColor, id, label, subPhases = []}) => {
    const { currPhase } = useScenario()
    const history  = useHistory()

    const clickHandler = (event) => {
        history.push(`${baseURL}/${id}`)
    }

    return (
        <div
            className={classnames("phase-nav", subPhases.length === 0 && "no-children")}
            style={{
                backgroundColor: (currPhase === id) ? activeColor : "transparent"
            }}
        >
            <div
                className={classnames(subPhases.length > 0 && "phase-label")}
            >
                <button
                    id={id}
                    onClick={clickHandler}
                    style={{
                        color: (currPhase === id ) ? "black" : "white"
                    }}
                >
                    {label}
                </button>
            </div>
            {subPhases.length > 0 && subPhases.map(sph => (
                <SubPhaseNav
                    key={sph.id}
                    baseURL={baseURL}
                    activeColor={activeColor}
                    id={sph.id}
                    label={sph.label}
                    phase={id}
                />
            ))}
        </div>
    )

//     if (subPhases.length > 0) {
//         return (
//             <div
//                 className="phase-nav"
//                 style={{
//                     backgroundColor: (currPhase === id) ? activeColor : "transparent"
//                 }}
//             >
//                 <div className="phase-label">
//                     <button
//                         id={id}
//                         onClick={clickHandler}
//                         style={{
//                             color: (currPhase === id) ? "black" : "white",
//                         }}
//                     >
//                         {label}
//                     </button>
//                 </div>
//                 {subPhases.map(sph=> (
//                     <SubPhaseNav
//                         key={sph.id}
//                         baseURL={baseURL}
//                         activeColor={activeColor}
//                         id={sph.id}
//                         label={sph.label}
//                         phase={id}
//                     />
//                 ))}
//             </div>
//         )
//     }
//     return (
//         <div
//             className="phase-nav no-children"
//             style={{ backgroundColor: (currPhase === id) ? activeColor : "transparent" }}
//         >
//             <button
//                 id={id}
//                 onClick={clickHandler}
//                 style={{
//                     color: (currPhase === id) ? "black" : "white",
//                 }}
//             >
//                 {label}
//             </button>
//         </div>
//     )
}

export default PhaseNav